import ApiService from '../../../../shared/services/api-service';
import commonActions from '../../../../shared/store/common/action-creators';
import usersActionCreators from './users';
import addressesActionsCreators from '../../addresses/action-creators';
import notificationsActionsCreator from '../../notifications/action-creators';

const userAddressesActionsCreators = {
  updateUserAddresses(formData) {
    const patchData = {
      data: formData.addresses,
      patched: 'addresses',
    };
    return async (dispatch) => {
      dispatch(this.setIsLoading('updateUserAddresses'));
      const data = await ApiService.patch(`/api/v1/users/${formData.userGuid}`, patchData)
        .then(response => response.data)
        .catch(error => ({ error }));
      dispatch(this.setIsLoading('updateUserAddresses'));
      if (data.error) {
        dispatch(commonActions.handleApiError(data.error));
      } else {
        dispatch(this.updateUserAddressesSuccess(data));
      }
    };
  },
  updateUserAddressesSuccess(updated) {
    return (dispatch) => {
      dispatch(usersActionCreators.replaceUser(updated.data));
      // This action handles success for both add and edit, so make sure we dispatch
      //   to reset both related state keys
      dispatch(addressesActionsCreators.resetAddressState());
      dispatch(notificationsActionsCreator.addSavedSuccessfully('User addresses updated'))
    };
  },
};

export default userAddressesActionsCreators;
